jQuery(document).ready(function($) {
  if ($(".ContactusContainer").length) {
    console.log("Contact Page JS File");

    /******************************************
     ***     Show Property on Google Maps   ***
     ******************************************/

    // if ($(".ContactusMap").length) {
    //   var lat = $("#map").data("lat");
    //   var long = $("#map").data("long");
    //   var myLatlng = {};
    //   myLatlng.lat = lat;
    //   myLatlng.lng = long;
    //   google.maps.event.addDomListener(window, "load", init);

    //   function init() {
    //     var mapOptions = {
    //       zoom: 16,
    //       scrollwheel: false,
    //       draggable: false,
    //       center: new google.maps.LatLng(lat, long),
    //       styles: [
    //         {
    //           featureType: "administrative",
    //           elementType: "labels.text.fill",
    //           stylers: [{ color: "#444444" }]
    //         },
    //         {
    //           featureType: "landscape",
    //           elementType: "all",
    //           stylers: [{ color: "#f2f2f2" }]
    //         },
    //         {
    //           featureType: "poi",
    //           elementType: "all",
    //           stylers: [{ visibility: "off" }]
    //         },
    //         {
    //           featureType: "road",
    //           elementType: "all",
    //           stylers: [{ saturation: -100 }, { lightness: 45 }]
    //         },
    //         {
    //           featureType: "road",
    //           elementType: "labels.text",
    //           stylers: [{ color: "#0b2a47" }]
    //         },
    //         {
    //           featureType: "road",
    //           elementType: "labels.text.stroke",
    //           stylers: [{ color: "#ffffff" }]
    //         },
    //         {
    //           featureType: "road.highway",
    //           elementType: "all",
    //           stylers: [{ visibility: "simplified" }]
    //         },
    //         {
    //           featureType: "road.arterial",
    //           elementType: "labels.icon",
    //           stylers: [{ visibility: "off" }]
    //         },
    //         {
    //           featureType: "transit",
    //           elementType: "all",
    //           stylers: [{ visibility: "off" }]
    //         },
    //         {
    //           featureType: "water",
    //           elementType: "all",
    //           stylers: [{ color: "#47ace9" }, { visibility: "on" }]
    //         }
    //       ]
    //     };
    //     var mapElement = document.getElementById("map");
    //     var map = new google.maps.Map(mapElement, mapOptions);
    //     var marker = new google.maps.Marker({
    //       position: new google.maps.LatLng(lat, long),
    //       map: map,
    //       icon: my_template_url + "/assets/images/icons/harcourts-map-icon.png"
    //     });
    //     map.addListener("center_changed", function() {
    //       window.setTimeout(function() {
    //         map.panTo(marker.getPosition());
    //       }, 500);
    //     });
    //   }
    // }

    /******************************************
     ***  END Show Property on Google Maps  ***
     ******************************************/
  }
});
